export const BOOKING_TYPES = {
  INSTANT: 'instant',
  REQUESTED: 'requested',
};

export const BOOKING_STATUSES = {
  RESERVED: 'reserved',
  CANCELLED: 'cancelled',
  NOT_RESPONDED: 'not_responsed',
};

export const BOOKING_STATUS_LABELS = {
  [BOOKING_STATUSES.RESERVED]: '予約済み',
  [BOOKING_STATUSES.CANCELLED]: 'キャンセル',
  [BOOKING_STATUSES.NOT_RESPONDED]: '未回答',
};

// TODO: GoToEat用1タイプ在庫登録フォーム(SimpleStocksForm)が廃止されたら消す
export const BOOKING_DEFAULT_DEADLINE_TIME_VALUE = '23:59:59';

// TODO: GoToEat用1タイプ在庫登録フォーム(SimpleStocksForm)が廃止されたら消す
export const BOOKING_DEADLINE_TIMES = [
  BOOKING_DEFAULT_DEADLINE_TIME_VALUE,
  '09:00:00',
  '09:30:00',
  '10:00:00',
  '10:30:00',
  '11:00:00',
  '11:30:00',
  '12:00:00',
  '12:30:00',
  '13:00:00',
  '13:30:00',
  '14:00:00',
  '14:30:00',
  '15:00:00',
  '15:30:00',
  '16:00:00',
  '16:30:00',
  '17:00:00',
  '17:30:00',
  '18:00:00',
  '18:30:00',
  '19:00:00',
  '19:30:00',
  '20:00:00',
  '20:30:00',
  '21:00:00',
  '21:30:00',
  '22:00:00',
  '22:30:00',
  '23:00:00',
  '23:30:00',
];

export const BOOKING_STAYING_TIMES = [
  {
    value: '1',
    title: '1時間',
  },
  {
    value: '1.5',
    title: '1.5時間',
  },
  {
    value: '2',
    title: '2時間',
  },
  {
    value: '2.5',
    title: '2.5時間',
  },
  {
    value: '3',
    title: '3時間',
  },
  {
    value: '3.5',
    title: '3.5時間',
  },
  {
    value: '4',
    title: '4時間',
  },
];
